import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from "@chakra-ui/react";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

export interface LinkProps extends ChakraLinkProps {
  children?: React.ReactNode;
  to: string;
}

export default function Link(props: LinkProps) {
  return (
    <ChakraLink asChild {...props}>
      <RouterLink to={props.to}>{props.children}</RouterLink>
    </ChakraLink>
  );
}
